// extracted by mini-css-extract-plugin
export var avatarContainer = "_7v-0";
export var avatarTypingWave = "_7v-i";
export var gray = "_7v-f";
export var green = "_7v-c";
export var icon = "_7v-9";
export var image = "_7v-1";
export var lg = "_7v-6";
export var md = "_7v-5";
export var presenceDot = "_7v-b";
export var red = "_7v-d";
export var sm = "_7v-4";
export var status = "_7v-a";
export var typingDot = "_7v-h";
export var typingPill = "_7v-g";
export var xl = "_7v-7";
export var xs = "_7v-3";
export var xxl = "_7v-8";
export var xxs = "_7v-2";
export var yellow = "_7v-e";